import Mutations from '../../odata/mutations';

export default { ...new Mutations('canSize'), ...new Mutations('canSizes') };
